var exports = {
  "kL": "ReportFlowThankYou.module__container___b3hMdz",
  "rf": "ReportFlowThankYou.module__body___b3hMdz",
  "uW": "ReportFlowThankYou.module__section___b3hMdz",
  "R_": "ReportFlowThankYou.module__heading___b3hMdz",
  "aP": "ReportFlowThankYou.module__box___b3hMdz",
  "nM": "ReportFlowThankYou.module__row___b3hMdz",
  "qg": "ReportFlowThankYou.module__rowText___b3hMdz",
  "G9": "ReportFlowThankYou.module__rowTitle___b3hMdz",
  "Z$": "ReportFlowThankYou.module__rowDescription___b3hMdz",
};

module.exports = exports;
